(ns admin.containers.curriculum.demo.feasibility
  (:require
   [re-frame.core :as re-frame]
   [applied-science.js-interop :as j]
   [reagent.core :as reagent]
   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.lib.kyber-db :as kyber-db]
   [kyber.components.base.icons :as icon]
   [kyber.components.base.text :as text]
   [kyber.components.composite.loading :as loading]
   [kyber.constants :as kc]
   [kyber.utils :as ku]))

(def selected-site (reagent/atom nil))

(def los
  ["Patient Population"
   "Facilities and Equipment"
   "Contracts, Budget, and IRB"
   "Personnel and Procedures"])

(def site-data
  {:swan-river
   {:title "Swan River Clinic"
    :contact "Michael Day; 854-555-6847; michael.day@sriverc.com"
    :overall 5.75
    :responded "Responded on Jan 27th, 2022 (7 days since invitation)"
    :los
    [{:score 2
      :questions ["How many patients with Celiac Disease do you manage at your clinic per year?"
                  "How many of your patients are typically on a gluten free diet?"
                  "Please share any inclusion or exclusion that might impact enrollment at your site."
                  "How many eligible subjects do you believe your site can enroll during the 3 month enrollment period?"]
      :answers [["6-10" :think]
                ["25%" :guess]
                ["Inclusion criteria 3 might be difficult because I'm not sure how many of our existing patients will agree to strictly be gluten free for the duration of the study. We also mostly have patients who are newly diagnosed and likely fall into the'uncontrolled' category (exclusion 3)"]
                ["3-5" :guess]]}
     {:score 7
      :questions ["Please share your thoughts on the Oral Gluten Challenge and if you forsee any issues in administering this procedure at your site"
                  "Please select the statements most applicable to your site"
                  "Does your site have a secured storage area for study product?"]
      :answers [["I'm not sure how this will actually be blinded? But we do have a little kitchen and plenty of storage for study materials."]
                ["Our site utilizes an established eISF we can grant Sponsor/CRA access to; Our site is experienced in utilizing a Sponsors eISF; Our site can grant Sponsor/CRA access to our EMR" :sure]
                ["Yes" :sure]]}
     {:score 6.75
      :questions ["Please indicate your site's requirements related to IRB submission and budget/contract negotiation:"
                  "Can your site utilize the Central IRB (WCG IRB)?"
                  "What is the average negotiation and approval time for contracts and budgeting?"]
      :answers [["No specific requirement" :sure]
                ["Yes" :sure]
                ["0-1 months" :think]]}
     {:score 7
      :questions ["Is there an infusion nurse on staff who would be able to administer CA120?"
                  "Does your site have staff trained to perform ECG assessments who will be available during subject visits?"
                  "What is the maxium number of clinical trials that your site can successfully participate in at one time?"
                  "How many clinical trials is your site currently participating in?"
                  "What strategies does your site have in place to ensure subject retention (select all that apply)"]
      :answers [["Yes" :sure]
                ["Yes" :sure]
                ["4-5" :sure]
                ["2-3" :sure]
                ["Study Visit Reminders; Branded milestone achievement cards, email newsletters" :sure]]}]}
   :mercy-vale
   {:title "Mercy Vale Community Hospital"
    :contact "Sarah House; 923-555-4943; shouse@mercyvale.com"
    :overall 6.75
    :responded "Responded on Jan 2nd, 2022 (16 days since invitation)"
    :los
    [{:score 7
      :questions ["How many patients with Celiac Disease do you manage at your clinic per year?"
                  "How many of your patients are typically on a gluten free diet?"
                  "Please share any inclusion or exclusion that might impact enrollment at your site."
                  "How many eligible subjects do you believe your site can enroll during the 3 month enrollment period?"]
      :answers [["21-30" :sure]
                [">76%" :sure]
                ["There aren't any inclusion/exclusion criteria that stand out to me."]
                ["3-5" :think]]}
     {:score 6.5
      :questions ["Please share your thoughts on the Oral Gluten Challenge and if you forsee any issues in administering this procedure at your site"
                  "Please select the statements most applicable to your site"
                  "Does your site have a secured storage area for study product?"]
      :answers [["We have limited cold storage for study materials (would that be required?)"]
                ["Our site utilizes an established eISF we can grant Sponsor/CRA access to; Our site is experienced in utilizing a Sponsors eISF" :think]
                ["Yes" :sure]]}
     {:score 6.5
      :questions ["Please indicate your site's requirements related to IRB submission and budget/contract negotiation:"
                  "Can your site utilize the Central IRB (WCG IRB)?"
                  "What is the average negotiation and approval time for contracts and budgeting?"]
      :answers [["Final budget required prior to IRB submission" :think]
                ["Yes" :sure]
                ["0-1 months" :think]]}
     {:score 6.5
      :questions ["Is there an infusion nurse on staff who would be able to administer CA120?"
                  "Does your site have staff trained to perform ECG assessments who will be available during subject visits?"
                  "What is the maxium number of clinical trials that your site can successfully participate in at one time?"
                  "How many clinical trials is your site currently participating in?"
                  "What strategies does your site have in place to ensure subject retention (select all that apply)"]
      :answers [["Yes" :sure]
                ["Yes" :sure]
                [">6" :think]
                ["4-5" :think]
                ["Study Visit Reminders; email newsletters; patient surveys" :sure]]}]}})

(def classes
  (styles->classes
   {:items-center
    {:display :flex
     :align-items :center}
    :details
    {:cursor :pointer
     "&:hover"
     {:background (gs [:colors :gray-scale-100])}}}))

(defn header [curriculum]
  [:div {:class (:items-center classes)
         :style {:background "white"
                 :height "80px"
                 :display :flex
                 :justify-content :space-between
                 :padding-left "20px"
                 :padding-right "20px"
                 :border-bottom (str "1px solid " (gs [:colors :gray-scale-200]))}}

   [:div {:style {:width "50%"}}
    [text/title-20 :span {:style {:display :block}} "Protocol"]
    [text/body-20 :span {} (:curriculum/name @curriculum)]]

   [:div {:class (:items-center classes)
          :style {:flex-grow 0
                  :width "50%"}}
    [:div {:style {:flex-shrink 0
                   :margin-right "25px"
                   :padding-right "25px"
                   :border-right (str "1px solid " (gs [:colors :gray-scale-300]))}}
     [text/title-20 :span {:style {:display :block}} "Site Responses"]
     [text/body-20 :span {} "38 out of 45 (84%)"]]
    [:div {:style {:width "100%"}}
     [:div {:style {:width "100%"}}
      (let [total-population (apply + [1 1 1 1 1 1 1 1 1 1])]
        [:<>
         [:ul {:style {:height "8px"
                       :width "100%"
                       :margin-top "4px"
                       :margin-bottom "6px"
                       :display :flex}}
          (for [{:keys [value idx]}
                (map-indexed (fn [idx value]
                               {:idx idx
                                :value (if (and (pos? value)
                                                (pos? total-population))
                                         (* (/ value total-population) 100)
                                         0)})
                             [1 1 1 1 1 1 1 1 1 1])]
            [:li {:style {:width (str value "%")
                          :background (get kc/readiness-scale-spectrum idx "#fff")}
                  :key idx}])]
         [:div {:style {:display :flex
                        :justify-content :space-between}}
          [text/caption-30 :span {:style {:white-space :nowrap}} "Least Feasible (0)"]
          [text/caption-30 :span {:style {:white-space :nowrap}} "Most Feasible (10)"]]])]]]])

(defn tabs []
  [:div {:class (:items-center classes)
         :style {:justify-content :space-between
                 :padding-top "20px"
                 :padding-left "20px"
                 :padding-right "20px"}}
   [:ul {:style {:border-radius :5px
                 :overflow :hidden
                 :display :flex
                 :border (str "1px solid " (gs [:colors :gray-scale-200]))}}
    [:li {:style {:padding "6px 10px 6px 12px"
                  :color :white
                  :background (gs [:colors :primary-lite-600])}}
     "Active (10)"]
    [:li {:style {:padding "6px 10px"
                  :background :white
                  :color (gs [:colors :gray-scale-700])
                  :border-right (str "1px solid " (gs [:colors :gray-scale-200]))}}
     "Archived (14)"]
    [:li {:style {:padding "6px 10px"
                  :background :white
                  :color (gs [:colors :gray-scale-700])
                  :border-right (str "1px solid " (gs [:colors :gray-scale-200]))}}
     "On Hold (14)"]
    [:li {:style {:padding "6px 12px 6px 10px"
                  :background :white
                  :color (gs [:colors :gray-scale-700])}}
     "Awaiting Response (7)"]]
   [:p {:style {:padding "6px 12px"
                :color :white
                :background (gs [:colors :primary-lite-600])
                :font-family (gs [:font-family :open-sans])
                :font-size :12px
                :border-radius :5px}}
    "Add Sites"]])

(defn card [{:keys [title sub-title date dots id]}]
  [:div (cond-> {:style {:background :white
                         :padding "8px"
                         :border-radius "5px"
                         :margin "10px 0"
                         :box-shadow "rgb(0 0 0 / 10%) 0px 0px 4px 0px"}}
          (some? id)
          (assoc :on-click #(reset! selected-site id)))
   [:div {:style {:display :flex
                  :align-items :start
                  :justify-content :space-between}}
    [:div
     [text/title-20 :span {:style {:display :block
                                   :color (gs [:colors :primary-lite-600])
                                   :margin-right "20px"}}
      title]
     [text/body-20 :span {:style {}}
      sub-title]]
    [:ul {:style {:display :flex}}
     (map-indexed
      (fn [idx dot]
        ^{:key (str idx "_" (keyword title) "_" dot)}
        [:li {:style {:width "11px"
                      :height "11px"
                      :display :block
                      :border-radius "50%"
                      :margin-left "3px"
                      :background (get kc/readiness-scale-spectrum dot "#ffffff")}}])
      dots)]]

   [:div {:style {:display :flex
                  :align-items :end
                  :justify-content :space-between}}
    [text/caption-20 :span {:style {:display :block}}
     date]
    [:p {:class (:details classes)
         :style {:padding "6px 12px"
                 :color (gs [:colors :primary-lite-600])
                 :font-family (gs [:font-family :open-sans])
                 :font-size :12px
                 :border-radius :5px
                 :margin 0
                 :border (str "1px solid " (gs [:colors :gray-scale-300]))}}
     "Details"]]])

(defn panel [{:keys [title cards]}]
  [:div {:style {:display :flex
                 :flex-direction :column
                 :width "33%"
                 :flex-grow 1
                 :padding "10px"}}
   [:div {:style {:flex "1 1 0"
                  :padding :15px
                  :border-radius "10px"
                  :background (gs [:colors :gray-scale-100])
                  :box-shadow "inset rgb(0 0 0 / 10%) 0px 0px 4px 0px"
                  :overflow :scroll}}
    [:div {:style {}}
     [text/title-30 :span {:style {:display :block
                                   :margin "0 0 15px"
                                   :padding 0}}
      title]
     (for [card-item cards]
       ^{:key card-item}
       [card card-item])]]])

(defn badge [confidence]
  [:div {:style {:margin-left "10px"
                 :border-radius "7px"
                 :padding "2px 6px 4px"
                 :background (case confidence
                               :sure "#DBE6F1"
                               :think "#F8EFE2"
                               "#F5E9E9")}}
   [text/caption-20 :span {:style {:font-weight 600}}
    (case confidence
      :sure "Confident"
      :think "Possibly"
      "Guessed")]])

(defn site-details []
  (let [{:keys [title contact overall responded] :as site}
        (get site-data @selected-site)]
    [:div {:style {:position :absolute
                   :top 0
                   :left 0
                   :right 0
                   :bottom 0
                   :background "rgba(0, 0, 0, 0.5)"
                   :z-index 1000}}
     [:div {:style {:height "100%"
                    :width "100%"
                    :position :absolute
                    :background "rgba(0, 113, 188, 0.15)"
                    :z-index 0}
            :on-click #(reset! selected-site nil)}]
     [:div {:style {:background "white"
                    :box-shadow "rgb(0 0 0 / 20%) 0px 0px 10px 0px"
                    :height "100%"
                    :width "60%"
                    :margin-left "40%"
                    :position :absolute
                    :overflow :scroll
                    :z-index 1}}
      [:div {:class (:items-center classes)
             :style {:padding "20px 0 0"}}
       [:div {:style {:width "100%"
                      :padding "0 20px"}}
        [:h1 {:style {:display :block
                      :font-family (gs [:font-family :open-sans])
                      :font-size "28px"
                      :font-weight 100}} title]
        [text/body-20 :em {} responded]
        [text/body-20 :p {:style {:margin 0}} contact]]
       [:div {:class (:items-center classes)
              :style {:padding-right "20px"}}
        [:div {:class (:items-center classes)
               :style {:flex-direction :column
                       :justify-content :center
                       :border (str "1px solid " (gs [:colors :gray-scale-300]))
                       :border-radius "3px"
                       :width "36px"
                       :height "36px"
                       :margin-right "10px"}}
         [:i.fa.fas.fa-archive {:style {:color (gs [:colors :primary-lite-600])}}]]
        [:div {:class (:items-center classes)
               :style {:flex-direction :column
                       :justify-content :center
                       :border (str "1px solid " (gs [:colors :gray-scale-300]))
                       :border-radius "3px"
                       :width "36px"
                       :height "36px"}}
         [:i.fa.fas.fa-arrow-right {:style {:color (gs [:colors :primary-lite-600])}}]]]]

      [:div {:class (:items-center classes)
             :style {:padding "20px 20px 0"
                     :margin "20px 0"
                     :align-items :stretch}}
       [:div {:style {:border (str "2px solid" (get kc/readiness-scale-spectrum overall))
                      :border-radius "4px"
                      :margin-right "20px"
                      :display :flex
                      :flex-direction :column
                      :justify-content :center
                      :text-align :center
                      :width "100px"}}
        [text/title-40 :span {:style {}} overall]
        [text/caption-30 :span {} "overall"]]
       [:div {:style {:width "100%"
                      :display :grid
                      :grid-template-columns "repeat(2, 1fr)"
                      :grid-template-rows "repeat(2, 1fr)"
                      :grid-column-gap 0
                      :grid-row-gap 0
                      :border-radius "4px"
                      :border (str "1px solid " (gs [:colors :gray-scale-300]))}}
        (map
         (fn [idx lo-title {:keys [score]}]
           [:div {:key (str "table_" lo-title)
                  :class (:items-center classes)
                  :style (cond-> {:justify-content :space-between
                                  :padding "8px"
                                  :margin "0 -1px -1px 0"}
                           (even? idx)
                           (assoc :border-right (str "1px solid " (gs [:colors :gray-scale-300])))
                           (zero? (rem 2 (inc idx)))
                           (assoc :border-bottom (str "1px solid " (gs [:colors :gray-scale-300]))))}
            [:div {:class (:items-center classes)}
             [:div {:style {:width "13px"
                            :height "13px"
                            :display :block
                            :border-radius "50%"
                            :margin-right "6px"
                            :background (get kc/readiness-scale-spectrum score)}}]
             [text/caption-30 :span {:style {:font-weight 500}} lo-title]]
            [text/caption-30 :span {:style {:font-weight 900}} (j/call score :toFixed 1)]])
         (range (count los))
         los
         (:los site))]]

      [:div
       (map
        (fn [lo-title {:keys [questions answers score]}]
          [:div {:key lo-title
                 :style {:padding "20px"
                         :border-bottom (str "1px solid " (gs [:colors :gray-scale-200]))}}
           [:div {:class (:items-center classes)}
            [icon/icon
             {:style {:margin-right "6px"
                      :color (cond
                               (< score 3) (gs [:colors :chart-red])
                               (< score 6) (gs [:colors :chart-orange])
                               :else "#0071bc")}}
             (cond
               (< score 3) :exclamation-triangle
               (< score 6) :warning-solid
               :else :check-circle)]
            [text/title-30 :p {:style {}} lo-title]]
           (map
            (fn [question [answer confidence]]
              [:div {:key question
                     :style {:padding-top "8px"}}
               [text/title-20 :p {:style {}} question]
               [:div {:class (:items-center classes)}
                [text/body-30 :p {:style {}} answer]
                (when confidence
                  [badge confidence])]])
            questions
            answers)])
        los
        (:los site))]]]))

(defn render [{{curriculum-uuid :curriculum-uuid} :params :as _context}]
  (let [curriculum
        (re-frame/subscribe
         [::kyber-db/get-record {:model :curriculum
                                 :ident curriculum-uuid}])]
    (fn [{:keys [resource-status]}]
      (if (ku/all-resources-loaded? resource-status)
        [:<>
         (when (some? @selected-site)
           [site-details])
         [:div {:style {:height "100%"
                        :position :relative}}
          [header curriculum]
          [:div {:style {:position :absolute
                         :top "80px"
                         :left 0
                         :bottom 0
                         :width "100%"
                         :display :flex
                         :flex-direction :column}}
           [tabs]
           [:div {:style {:display :flex
                          :flex-grow 1
                          :padding :10px}}
            [panel {:title "For Review (7)"
                    :cards [{:id :swan-river
                             :title "Swan River Clinic"
                             :dots [1 9 7 8]
                             :sub-title "Mostly great, poor in 1 area"
                             :date "Responded 01/27/2022"}
                            {:title "Heartstone Hospital Center"
                             :dots [7 4 6 5]
                             :sub-title "Mostly OK"
                             :date "Responded 01/25/2022"}
                            {:title "Spring Grove Medical Center"
                             :dots [2 3 5 6]
                             :sub-title "OK in some areas, poor in others"
                             :date "Responded 01/26/2022"}
                            {:title "Southshore Hospital"
                             :dots [2 1 3 7]
                             :sub-title "Poor in most areas"
                             :date "Responded 01/25/2022"}
                            {:title "Garden Grove Clinic"
                             :dots [0 2 3 1]
                             :sub-title "Poor in all areas"
                             :date "Responded 01/19/2022"}
                            {:title "Silver Birch Medical Clinic"
                             :dots [2 1 0 2]
                             :sub-title "Poor in all areas"
                             :date "Responded 01/16/2022"}
                            {:title "Union Medical Center"
                             :dots [0 1 1 1]
                             :sub-title "Poor in all areas"
                             :date "Responded 01/15/2022"}]}]
            [panel {:title "In Contract (2)"
                    :cards [{:title "Hill Crest Hospital"
                             :dots [7 6 6 5]
                             :sub-title "OK in all areas"
                             :date "Responded 01/14/2022"}
                            {:title "Springfield Hospital"
                             :dots [7 7 8 5]
                             :sub-title "Good in all areas"
                             :date "Responded 01/09/2022"}]}]
            [panel {:title "Start Up (1)"
                    :cards [{:id :mercy-vale
                             :title "Mercy Vale Community Hospital"
                             :dots [8 9 7 8]
                             :sub-title "Great in all areas"
                             :date "Responded 01/02/2022"}]}]]]]]
        [loading/render
         {:loading-message "Please wait while we fetch your reports"}]))))

